module.exports = "\n<p>Hellow world</p>"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/user/user.component.html
// module id = ../../../../../src/app/admin/page/user/user.component.html
// module chunks = main